import React, { useState, useEffect, useRef } from 'react';

function ScrollTop(){
    const scrollRef = useRef();
    const [winHeight, setWinHeight] = useState(1000);
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        // create variable for initial window height
        let initWindowHeight = window.innerHeight;
        setWinHeight(initWindowHeight);

        const onScroll = () => setShowScroll(scrollRef.current.offsetTop > winHeight);

        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    // eslint-disable-next-line
    }, []);

    const scrollToTop = () => {
        // scroll to top of page smooth
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    return (
        <div ref={ scrollRef } className={ 'sticky float-right w-8 h-11 right-2 bg-white bottom-2 border border-[#97afb4] flex flex-col items-center p-1 text-[#97afb4] cursor-pointer' + (showScroll ? ' visible': ' invisible') } onClick={() => scrollToTop()}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="4" stroke="currentColor" className="w-6 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18" />
            </svg>
            <div className='text-sm'>TOP</div>
        </div>
    );
}

export default ScrollTop;